import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

const SharePointCallback = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [processing, setProcessing] = useState(true);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const error = params.get('error');
        const errorDescription = params.get('error_description');
        const state = params.get('state');

        if (error) {
          throw new Error(errorDescription || error);
        }

        if (!code) {
          throw new Error('No authorization code received');
        }

        console.log('SharePoint callback received code, calling edge function...');

        // Get redirect URI from config
        const { data: config } = await supabase.functions.invoke('get-sharepoint-config');
        const redirectUri = config?.sharepointRedirect || `${window.location.origin}/sharepoint-callback`;
        
        // Call the sharepoint-auth edge function (uses automatic Authorization header)
        const { data, error: authError } = await supabase.functions.invoke('sharepoint-auth', {
          body: { code, redirectUri }
        });

        if (authError) {
          console.error('Edge function error:', authError);
          throw authError;
        }

        console.log('SharePoint auth successful:', data);

        // Close popup if we're in one
        if (window.opener) {
          window.opener.postMessage({ type: 'sharepoint-auth-success' }, window.location.origin);
          window.close();
        } else {
          // If not in popup, redirect to projects page
          toast({
            title: 'SharePoint verbonden',
            description: 'Je SharePoint account is succesvol gekoppeld'
          });
          navigate('/crm/projects');
        }
      } catch (error) {
        console.error('SharePoint callback error:', error);
        
        const errorMessage = error instanceof Error ? error.message : 'Onbekende fout';
        
        if (window.opener) {
          window.opener.postMessage({ 
            type: 'sharepoint-auth-error',
            error: errorMessage 
          }, window.location.origin);
          window.close();
        } else {
          toast({
            title: 'SharePoint koppeling mislukt',
            description: errorMessage,
            variant: 'destructive'
          });
          navigate('/crm/projects');
        }
      } finally {
        setProcessing(false);
      }
    };

    handleCallback();
  }, [navigate, toast]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        {processing ? (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
            <p className="text-muted-foreground">SharePoint koppeling verwerken...</p>
          </>
        ) : (
          <p className="text-muted-foreground">Verwerking voltooid</p>
        )}
      </div>
    </div>
  );
};

export default SharePointCallback;
